import { RootState } from '~/store';

export const descriptionInputsSelector = (state: RootState) => state.bookEdit.descriptionInputs;
